import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-height: 80vh;
	display: grid;
	grid-template-columns: 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
		min-height: 100%;
	}
`;

export const box = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		flex-direction: column;
	}
`;
